import React, {Component} from 'react';
import {ButtonToolbar, ControlLabel} from "react-bootstrap";
import {CSVLink} from "react-csv";
import {TopButtonAction} from "../buttons/TopButtons";
import {TopSelect} from "../selects/TopSelects";
import {TopAlertInformacja} from "../alerty/TopAlerts";
import PropTypes from "prop-types";
import TopDostepnosc from "../dostepnosc/TopDostepnosc";

export default class TopExportCSV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            separatory: [
                {value: ";", label: "; średnik"},
                {value: " ", label: "spacja"},
                {value: "\t", label: "tabulator"},
                {value: "/", label: "/ ukośnik"},
                {value: ",", label: ", przecinek"},
            ],
            opcjeexportu: {
                separator: {value: ";", label: "; średnik"},
                kolumnyDoExportu: []
            },
            pokazModal: false,

            wszystkieKolumny: [],

            daneDoExportu: [],
        };
    }

    componentDidMount() {
        if (Boolean(this.props.kolumnyDoExportu)) {
            this.przygotujDaneDoEksportu(this.props.daneRest, this.props.kolumnyDoExportu)
        } else {
            this.przygotujDaneDoEksportu(this.props.daneRest)
        }

        let obj = this.state.opcjeexportu
        obj['kolumnyDoExportu'] = this.props.kolumnyDoExportu
        this.setState({
            opcjeexportu: obj,
            wszystkieKolumny: this.props.wszystkieKolumny
        })

    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.kolumnyDoExportu)) {
            this.przygotujDaneDoEksportu(nextprops.daneRest, nextprops.kolumnyDoExportu)
        } else {
            this.przygotujDaneDoEksportu(nextprops.daneRest)
        }

        let obj = this.state.opcjeexportu
        obj['kolumnyDoExportu'] = nextprops.kolumnyDoExportu
        this.setState({
            opcjeexportu: obj,
            wszystkieKolumny: nextprops.wszystkieKolumny
        })
    }

    przygotujDaneDoEksportu(dane, kolumny = this.state.opcjeexportu.kolumnyDoExportu) {
        if (dane) {
            let array = Array.from(dane, item => {
                let obj = {}

                for (let i = 0; i < kolumny.length; i++) {
                    obj = Object.assign(obj, {[kolumny[i].label]: item[kolumny[i].value]})
                }

                return obj
            })

            this.setState({daneDoExportu: array})
        }
    }

    onChangeSeparator(e) {
        let object = this.state.opcjeexportu
        object["separator"] = e
        this.setState({opcjeexportu: object})
    }

    onChangeKolumnyDoExportu(e) {
        let object = this.state.opcjeexportu
        object["kolumnyDoExportu"] = e
        this.setState({opcjeexportu: object})

        this.przygotujDaneDoEksportu(this.props.daneRest, e)
    }

    render() {

        return (
            <div>
                <div style={{marginTop:'5px'}}>
                    <div className={'pull-left'} style={{marginBottom: '3px'}}>
                        <ButtonToolbar>
                            <CSVLink data={this.state.daneDoExportu} separator={this.state.opcjeexportu.separator.value}
                                     className={'btn btn-info btn-xs'}>
                                <span style={{fontWeight: 'bold'}}><i className={'fa fa-download'}></i> Pobierz dane w pliku CSV</span>
                            </CSVLink>
                            <TopButtonAction btnColor={'default'} iconType={'fa fa-cogs'} text={'Opcje eksportu'} btnSize={'xs'} onClick={() => {
                                this.setState({pokazModal: true})
                            }}/>
                            {
                                this.props.czyPokazacDoDruku &&
                                <TopButtonAction text={'Wygeneruj PDF do druku'} btnSize={'xs'} iconType={'fa fa-print'} onClick={()=>this.props.onClickPrint()}/>
                            }
                        </ButtonToolbar>
                    </div>
                </div>
                <div>
                    {
                        this.state.pokazModal ?
                            <div id={'EBUSModalContainerBG'}>
                                <div id={'modalContainer'}>
                                    <div>
                                        <div id={'modalTextContent'} style={{width: '750px'}}>
                                            <div>
                                                <div className={'pull-right'}>
                                                    <TopButtonAction onClick={() => {
                                                        this.setState({pokazModal: false})
                                                    }}
                                                                     elementStyle={{color: 'firebrick'}}
                                                                     btnColor={'default'} text={'Zamknij'}
                                                                     iconType={'fa fa-times'}
                                                    />

                                                </div>
                                                <div style={{clear: 'both', height: '10px'}}></div>
                                            </div>
                                            <div>
                                                <div>
                                                    <div>
                                                        <ControlLabel>Separator</ControlLabel>
                                                    </div>
                                                    <div style={{width: '300px', marginBottom: '15px'}}>
                                                        <TopSelect clearable={false} onChange={(e) => this.onChangeSeparator(e)}
                                                                   value={this.state.opcjeexportu.separator}
                                                                   options={this.state.separatory}/>
                                                    </div>
                                                </div>
                                                <div>
                                                    <ControlLabel>Kolumny do eksportu</ControlLabel>
                                                </div>
                                                <div>
                                                    <TopSelect clearable={false} multi onChange={(e) => this.onChangeKolumnyDoExportu(e)}
                                                               value={this.state.opcjeexportu.kolumnyDoExportu}
                                                               options={this.state.wszystkieKolumny}/>
                                                </div>
                                                <div style={{marginTop: '15px'}}>
                                                    <TopAlertInformacja text={'Ustawienia zapisują się automatycznie, na zdarzenie zmiany wartości'}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ""
                    }
                </div>
            </div>
        );
    }
}

TopExportCSV.propTypes = {
    daneRest: PropTypes.array.isRequired,
    wszystkieKolumny: PropTypes.array.isRequired,
    kolumnyDoExportu: PropTypes.array,
    czyPokazacDoDruku: PropTypes.bool,
    onClickPrint: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/componentsTopsa/exportCSV/TopExportCSV.js